import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Button } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import Lock from '@material-ui/icons/Lock';
import { connect } from "react-redux";
import { compose } from "redux";
import logo from "../assets/logo.png";
import { changePasswordAction } from "../actions/SessionAction";
const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    img: {
        margin: 'auto',
        display: 'block',
        maxWidth: '70%',
        maxHeight: '100%',

    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: `calc(100% - ${theme.spacing.unit * 2}px)`
    },
    input: {
        display: 'none',
    },
    inputStyle: {
        padding: '12px 5px',
        fontSize: 15,
        color: 'rgba(0, 0, 0, 0.87)',
    },
    margin: {
        margin: theme.spacing.unit,
    },
    button: {
        margin: theme.spacing.unit,
    },
    gradientBackground: {
        background: 'linear-gradient(to right, #2926ac 0%, #6128be 100%)',
        // background: 'linear-gradient(to right, #2926ac 0%, #0a0a0a 100%)',
        transition: '1200ms',
        zIndex: 3,
        // opacity: 0.7
    },

})

class ChangePassword extends Component {

    static contextTypes = {
        router: PropTypes.object,
    }

    constructor() {
        super();
        this.state = {
            password: "",
            confirm_password: "",
            password_error: false,
            confirm_password_error: false,
            invalid_password_error: false,
            invalid_confirm_password_error: false,
            token: ""
        }
    }
    componentDidMount() {
        const  { token }  = this.props.match.params
        const data = decodeURIComponent(token);
        this.setState({ token: data });    
    }

    validateEmail(email) {
        var re = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    submitForm = () => {
        let isError = false
        if (this.state.password !== null && this.state.password !== "") {
            if (!(this.state.password.length >= 8)) {
                this.setState({ invalid_password_error: true })
                isError = true
            }
        } else {
            this.setState({ password_error: true })
            isError = true
        }

        if (this.state.confirm_password !== null && this.state.confirm_password !== "") {
            if (!(this.state.password === this.state.confirm_password)) {
                this.setState({ invalid_confirm_password_error: true })
                isError = true
            }
        } else {
            this.setState({ confirm_password_error: true })
            isError = true
        }

        if (isError === false) {
            let userObj = {};
            userObj.password = this.state.password
            userObj.token = this.state.token
            this.props.dispatch(changePasswordAction(this, userObj))           
        }
    }

    render() {
        const { classes } = this.props;
        return (
            <div className={classes.root} style={{marginTop: "75px", marginBottom: "75px"}}>
                <Grid container spacing={0}>
                <Grid container item xs={6} className={classes.gradientBackground}>
                        <Grid item xs={12} style={{ justifyContent: "center", alignSelf: "center" }}>
                            <img src={logo} className={classes.img} alt="Logo" />
                        </Grid>
                    </Grid>
                    <Grid item xs={6} style={{ paddingTop: '10%', paddingBottom: '10%',backgroundColor: "white" }} >
                        <Grid item xs={12} >
                            <center>
                                <TextField
                                    className={classes.margin}
                                    id="password"
                                    placeholder="Password"
                                    variant="outlined"
                                    type="password"
                                    onChange={(event) => this.setState({ password: event.target.value, password_error: false, invalid_password_error: false})}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Lock />
                                            </InputAdornment>
                                        ),
                                        classes: { input: classes.inputStyle }
                                    }}
                                    error={this.state.password_error === true ? true : this.state.invalid_password_error === true ? true : false}
                                    helperText={this.state.password_error === true ? "Please enter password" : this.state.invalid_password_error === true ? "Password length minimum 8 character" : null}
                                    onKeyPress={(e) => { if (e.key === 'Enter') { this.submitForm() } }}
                                />
                            </center>
                        </Grid>
                        <Grid item xs={12} >
                            <center>
                                <TextField
                                    className={classes.margin}
                                    id="confirm_password"
                                    placeholder="Confirm Password"
                                    variant="outlined"
                                    type="password"
                                    onChange={(event) => this.setState({ confirm_password: event.target.value, invalid_confirm_password_error: false, confirm_password_error: false})}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Lock />
                                            </InputAdornment>
                                        ),
                                        classes: { input: classes.inputStyle }
                                    }}
                                    error={this.state.confirm_password_error === true ? true : this.state.invalid_confirm_password_error === true ? true : false}
                                    helperText={this.state.confirm_password_error === true ? "Please enter password" : this.state.invalid_confirm_password_error === true ? "Please enter same password" : null}
                                    onKeyPress={(e) => { if (e.key === 'Enter') { this.submitForm() } }}
                                />
                            </center>
                        </Grid>
                        <Grid item xs={12} >
                            <center>
                            <Button size="small" variant="contained" color="secondary" className={classes.button} onClick={() => this.props.history.push('/')}>
                                    Cancel
                                </Button>
                                <Button size="small" variant="contained" color="primary" className={classes.button} onClick={this.submitForm}>
                                    Submit
                                </Button>
                            </center>
                        </Grid>
                     </Grid>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        loginError: state.SessionReducer.loginError
    }
}

ChangePassword.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default compose(withStyles(styles), connect(mapStateToProps))(ChangePassword);
